module.exports = __webpack_public_path__ + "img/crm_case2.1e536446.png";